/*
 * Bewertungen (Startseite): die Pfeile blaettern die Reihe, "Weiterlesen" klappt
 * lange Texte auf. Ohne JavaScript laesst sich die Reihe von Hand schieben und
 * jeder Text steht ganz da; die Pfeile und Knoepfe erscheinen erst mit JavaScript.
 */
(function () {
  'use strict';

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var aktiv = [];

  function einrichten(wurzel) {
    if (wurzel.hasAttribute('data-bewertungen-bereit')) return;
    wurzel.setAttribute('data-bewertungen-bereit', '');

    var spur = wurzel.querySelector('[data-bewertungen-spur]');
    var pfeile = wurzel.querySelector('[data-bewertungen-pfeile]');
    var zurueck = wurzel.querySelector('[data-bewertungen-zurueck]');
    var weiter = wurzel.querySelector('[data-bewertungen-weiter]');
    var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-bewertung-mehr]'));

    function textZu(knopf) {
      return document.getElementById(knopf.getAttribute('aria-controls'));
    }

    /* "Weiterlesen" nur dort zeigen, wo der Text wirklich abgeschnitten ist */
    function knoepfePruefen() {
      knoepfe.forEach(function (knopf) {
        var text = textZu(knopf);
        if (!text || text.hasAttribute('data-offen')) return;
        knopf.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    function beiKlick(e) {
      var knopf = e.target.closest ? e.target.closest('[data-bewertung-mehr]') : null;
      if (!knopf || !wurzel.contains(knopf)) return;
      var text = textZu(knopf);
      if (!text) return;
      var offen = text.toggleAttribute('data-offen');
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      knopf.textContent = knopf.getAttribute(offen ? 'data-text-weniger' : 'data-text-mehr');
    }
    wurzel.addEventListener('click', beiKlick);

    /* Pfeile: am Anfang und am Ende gesperrt; passt alles in die Breite, entfallen sie */
    var geplant = false;
    function pfeileSetzen() {
      geplant = false;
      if (!spur || !zurueck || !weiter) return;
      var max = spur.scrollWidth - spur.clientWidth;
      if (pfeile) pfeile.hidden = max <= 2;
      zurueck.disabled = spur.scrollLeft <= 2;
      weiter.disabled = spur.scrollLeft >= max - 2;
    }
    function beiScroll() {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(pfeileSetzen);
    }
    function blaettern(richtung) {
      spur.scrollBy({
        left: richtung * Math.max(240, spur.clientWidth * 0.85),
        behavior: wenigBewegung.matches ? 'auto' : 'smooth'
      });
    }
    function zurueckKlick() { blaettern(-1); }
    function weiterKlick() { blaettern(1); }
    if (spur && zurueck && weiter) {
      zurueck.addEventListener('click', zurueckKlick);
      weiter.addEventListener('click', weiterKlick);
      spur.addEventListener('scroll', beiScroll, { passive: true });
    }

    function beiGroesse() {
      beiScroll();
      knoepfePruefen();
    }
    window.addEventListener('resize', beiGroesse, { passive: true });
    window.addEventListener('load', beiGroesse);
    pfeileSetzen();
    knoepfePruefen();

    aktiv.push({
      wurzel: wurzel,
      aufraeumen: function () {
        window.removeEventListener('resize', beiGroesse);
        window.removeEventListener('load', beiGroesse);
      }
    });
  }

  function start(bereich) {
    var liste = (bereich || document).querySelectorAll('[data-bewertungen]');
    for (var i = 0; i < liste.length; i++) einrichten(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    aktiv = aktiv.filter(function (eintrag) {
      if (!e.target.contains(eintrag.wurzel)) return true;
      eintrag.aufraeumen();
      return false;
    });
  });
})();
